import ChannelService from '../../../../../services/channel';
import useInfiniteFetch, {
  FetchFn,
} from '../../../../../hooks/useInfiniteFetch';
import { useCallback } from 'react';
import {
  Follower,
  mapMember,
} from '../../../../../common/channel/channel-member';

export type { Follower };

export function useMembers(topicId: string, pageSize = 40) {
  const fetchData = useCallback<FetchFn<Follower>>(
    async (page, pageSize) => {
      const channel = new ChannelService(topicId);
      const res = await channel.fetchMembers(pageSize, page);
      return {
        data: res.data.data.map(mapMember),
        meta: {
          total: res.data.meta.total_records,
          pageSize: res.data.meta.page_size,
          currentPage: res.data.meta.current_page,
        },
      };
    },
    [topicId]
  );
  return useInfiniteFetch<Follower>(fetchData, pageSize);
}
